// extracted by mini-css-extract-plugin
module.exports = {"star":"StarToggle--star--85yi2","active":"StarToggle--active--1o6Gs"};